import React, { Component } from 'react'
import PageWrapper from './PageWrapper'
import FourOFourBody from './FourOFourBody'
import Section0 from './sections/Section0HelpLevel'
import Section1 from './sections/Section1MonthlyCosts'
import Section2 from './sections/Section2MonthlyCosts'
import Section3 from './sections/Section3MonthlyCosts'
import Section4 from './sections/Section4MonthlyCosts'
import Section5 from './sections/Section5Timing'
import Section6 from './sections/Section6Savings'
import Section7 from './sections/Section7Income'
import Section8 from './sections/Section8Results'

/**
 * A basic component that is responsible for handling the rendering of the
 * different sections depending on what params it is given via react-router
 */
export default class CalcContainer extends Component {
  /**
   * Render the component
   */
  render () {
    const totalSections = 7
    const section0Title = `Select Level of Expertise`
    const section1Title = `1 of ${totalSections}: Monthly Costs, Basics`
    const section2Title = `2 of ${totalSections}: Monthly Costs, Extras`
    const section3Title = `3 of ${totalSections}: Monthly Costs, Freedom`
    const section4Title = `4 of ${totalSections}: Monthly Costs, Review`
    const section5Title = `5 of ${totalSections}: Timing`
    const section6Title = `6 of ${totalSections}: Savings`
    const section7Title = `7 of ${totalSections}: Income`
    const section8Title = `Results`

    let section
    switch (this.props.match.params.section) {
      case '0': {
        section = <Section0 title={section0Title} />
        break
      }
      case '1': {
        section = <Section1 title={section1Title} />
        break
      }
      case '2': {
        section = <Section2 title={section2Title} />
        break
      }
      case '3': {
        section = <Section3 title={section3Title} />
        break
      }
      case '4': {
        section = <Section4 title={section4Title} />
        break
      }
      case '5': {
        section = <Section5 title={section5Title} />
        break
      }
      case '6': {
        section = <Section6 title={section6Title} />
        break
      }
      case '7': {
        section = <Section7 title={section7Title} />
        break
      }
      case '8': {
        section = <Section8 title={section8Title} />
        break
      }
      default: {
        section = <FourOFourBody />
        break
      }
    }
    return <PageWrapper>{section}</PageWrapper>
  }
}



// WEBPACK FOOTER //
// ./src/components/CalcContainer.js